<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { authStore } from '@/stores/auth.js'
const router = useRouter()
const checking = ref(false)
async function refreshAssignment() {
  if (checking.value) return
  checking.value = true
  try {
    const target = await authStore.refreshSelectedTenantWorkspace()
    await router.replace(target)
  } finally {
    checking.value = false
  }
}
onMounted(refreshAssignment)
async function logout() {
  await authStore.logout()
  await router.replace('/login')
}
</script>

<template>
  <section class="workspace-placeholder" aria-labelledby="waiting-title">
    <div class="workspace-badge" aria-hidden="true">恢</div>
    <p class="eyebrow">WORKSPACE RECOVERY</p>
    <h1 id="waiting-title">正在恢复企业资料工作区</h1>
    <p>系统正在为当前账号创建或恢复企业资料工作区，不需要企业管理员分配项目。</p>
    <p class="status-note">如果页面没有自动进入，请重新读取一次。</p>
    <div class="waiting-actions">
      <button class="primary-action" type="button" :disabled="checking" @click="refreshAssignment">{{ checking ? '正在恢复…' : '重新读取工作区' }}</button>
      <button class="text-button" type="button" @click="logout">退出登录</button>
    </div>
  </section>
</template>

<style scoped>
.waiting-actions{display:flex;flex-wrap:wrap;align-items:center;gap:12px;margin-top:20px}.primary-action{min-height:42px;padding:0 18px;border:0;border-radius:10px;color:#fff;background:#0b8379;font-weight:800}.primary-action:disabled{opacity:.65}
</style>
